import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { TeamsWebhookService } from './teams-webhook.service';

interface MyIpResponse {
  ip?: string;
  success?: boolean;
  type?: string;
}

@Injectable({
  providedIn: 'root',
})
export class VisitorsService {
  private readonly MYIP_URL = 'https://api.my-ip.io/ip.json';
  private _clientIp: MyIpResponse;

  constructor(private http: HttpClient, private webhook: TeamsWebhookService) {
    this.init();
  }

  public getIpAddress(): Observable<MyIpResponse> {
    if (this._clientIp) {
      return of(this._clientIp);
    } else {
      return this.http.get(this.MYIP_URL).pipe(
        tap((res) => {
          this._clientIp = res;
        }),
        catchError(this.handleError)
      );
    }
  }

  private init() {
    this.http.get(this.MYIP_URL).subscribe((res) => {
      this._clientIp = res;
      this.webhook.setClientIP(this._clientIp.ip);
    });
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
